interface AppConfig {
    BASE_URL: string;
    MAPBOX_TOKEN: string;
    GOOGLE_CLIENT_ID: string;
}

let config: AppConfig;

export const initConfig = async (): Promise<void> => {
    const response = await fetch("/env.json");
    const env = await response.json();

    config = {
        BASE_URL: env.REACT_APP_BASE_URL,
        MAPBOX_TOKEN: env.REACT_APP_MAPBOX_TOKEN,
        GOOGLE_CLIENT_ID: env.REACT_APP_GOOGLE_CLIENT_ID
    };
};

export const getConfig = (): AppConfig => {
    return config;
};